<mat-card appearance="outlined">
    <mat-card-header>
        <mat-card-title>{{title}}</mat-card-title>
        <mat-card-subtitle>{{description}}</mat-card-subtitle>
        <button mat-icon-button matTooltip="Diagram type" [matMenuTriggerFor]="chartTypes" *ngIf="!showTable">
            <mat-icon>bar_chart</mat-icon>
        </button>
        <mat-menu #chartTypes="matMenu">
            <button mat-menu-item (click)="type = 'line'; rerender();" *ngIf="disabledGraphs.indexOf('line') === -1">
                <span>Line</span>
            </button>
            <button mat-menu-item (click)="type = 'bar'; rerender();" *ngIf="disabledGraphs.indexOf('bar') === -1">
                <span>Bar</span>
            </button>
            <button mat-menu-item (click)="type = 'pie'; rerender();" *ngIf="disabledGraphs.indexOf('pie') === -1">
                <span>Pie</span>
            </button>
            <button mat-menu-item (click)="type = 'doughnut'; rerender();" *ngIf="disabledGraphs.indexOf('doughnut') === -1">
                <span>Doughnut</span>
            </button>
            <button mat-menu-item (click)="type = 'radar'; rerender();" *ngIf="disabledGraphs.indexOf('radar') === -1">
                <span>Radar</span>
            </button>
            <button mat-menu-item (click)="type = 'polarArea'; rerender();" *ngIf="disabledGraphs.indexOf('polarArea') === -1">
                <span>Polar Area</span>
            </button>
        </mat-menu>

        <button mat-icon-button matTooltip="Refresh" (click)="getData.emit()">
            <mat-icon>refresh</mat-icon>
        </button>

        <button mat-icon-button matTooltip="Table view" (click)="showTable = !showTable;  showInformation = false;">
            <mat-icon>table_chart</mat-icon>
        </button>

        <button type="button" mat-icon-button (click)="downloadXlsx()" matTooltip="Export to Excel">
            <mat-icon>cloud_download</mat-icon>
        </button>

        <!--button mat-icon-button matTooltip="Informatie weergave"
                (click)="showInformation = !showInformation; showTable = false;">
            <mat-icon>info</mat-icon>
        </button-->
    </mat-card-header>
    <mat-card-content *ngIf="widget">
        <ng-container *ngIf="!showTable; else tableView">
            <canvas #baseChart *ngIf="widget.datasets && widget.datasets.length > 0" baseChart [type]="type"
                    [datasets]="data ? data : widget.datasets" [labels]="widget.labels"
                    [options]="options"></canvas>
        </ng-container>
        <ng-template #tableView>
            <table class="mat-mdc-table">
                <tr>
                    <th></th>
                    <th *ngFor="let ds of widget.datasets">{{ds.label}}</th>
                </tr>
                <tr *ngFor="let label of widget.labels; let i = index">
                    <td>{{label}}</td>
                    <td *ngFor="let ds of widget.datasets">{{ds.data[i]}}</td>
                </tr>
            </table>
        </ng-template>
    </mat-card-content>
</mat-card>
